<button class="touch-select-trigger" [disabled]="disabled" (click)="open()">
  <span class="touch-select-trigger-label">{{ displayLabel }}</span>
  <span class="touch-select-trigger-caret">▾</span>
</button>

<app-modal
  *ngIf="isOpen"
  [contentStyle]="{
    width: 'min(520px, 80vw)',
    minHeight: '520px',
    height: 'auto',
    padding: '16px 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }"
  (onVisibleChange)="handleVisibleChange($event)"
  class="touch-select-modal"
>
  <div class="touch-select-header">
    <div class="touch-select-title">{{ step === 'first' ? placeholder : secondPlaceholder }}</div>
    <button class="action-btn" type="button" (click)="step === 'first' ? close() : backToFirst()">
      <ng-container *ngIf="step === 'first'; else backButton">
        <span class="icon">&times;</span>
        <span class="label">Close</span>
      </ng-container>
      <ng-template #backButton>
        <span class="label">Back</span>
      </ng-template>
    </button>
  </div>

  <div class="steps-viewport">
    <div class="steps-track" [class.steps-track--second]="twoStepMode && step === 'second'">
      <div class="step-panel">
        <div class="touch-select-list">
          <button
            class="touch-select-item"
            [class.touch-select-item--centered]="centerItemLabel"
            *ngFor="let opt of options"
            (click)="choose(opt)"
          >
            <span class="label">{{ opt[optionLabelKey] || opt.label }}</span>
          </button>
          <div class="touch-select-empty" *ngIf="(options?.length || 0) === 0">No options</div>
        </div>
      </div>
      <div class="step-panel">
        <div class="touch-select-list">
          <div class="touch-select-loading" *ngIf="secondLoading">
            <div class="inline-spinner"></div>
          </div>
          <ng-container *ngIf="!secondLoading">
            <button
              class="touch-select-item"
              [class.touch-select-item--centered]="centerItemLabel"
              *ngFor="let opt of dependentOptions || []"
              (click)="choose(opt)"
            >
              <span class="label">{{ opt[optionLabelKey] || opt.label }}</span>
            </button>
            <div class="touch-select-empty" *ngIf="dependentOptions?.length === 0">No options</div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</app-modal>
